import React, { useCallback, useRef } from 'react';
import { Modal as AntdModal } from 'antd'; // TODO 已经支持从zen-design里取

import classNames from 'classnames';
import ModalRender from './modalRender';
import { jsx as _jsx } from "react/jsx-runtime";
const useModal = widthContext => {
  const [contextModal, contextHolder] = AntdModal.useModal();
  const modalRef = useRef();
  const open = useCallback(opts => {
    const {
      width,
      centered,
      zIndex = 1000,
      mask,
      prefixClass = 'zen-design',
      //TODO 写provider时统一改掉
      className,
      style,
      ...renderProps
    } = opts;
    const baseClassName = "".concat(prefixClass, "-modal");
    modalRef.current = (widthContext ? contextModal : AntdModal).confirm({
      width,
      className: classNames(className, baseClassName),
      style,
      centered,
      zIndex,
      mask,
      modalRender: () => /*#__PURE__*/_jsx(ModalRender, {
        ...renderProps,
        onClose: () => {
          var _modalRef$current;
          return (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.destroy();
        }
      })
    });
  }, []);
  const close = useCallback(() => {
    var _modalRef$current2;
    (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 || _modalRef$current2.destroy();
  }, [modalRef.current]);
  const update = useCallback(opts => {
    var _modalRef$current3;
    const {
      width,
      centered,
      zIndex = 1000,
      mask,
      prefixClass = 'zen-design',
      //TODO 写provider时统一改掉
      className,
      style,
      ...renderProps
    } = opts;
    const baseClassName = "".concat(prefixClass, "-modal");
    (_modalRef$current3 = modalRef.current) === null || _modalRef$current3 === void 0 || _modalRef$current3.update({
      width,
      className: classNames(className, baseClassName),
      style,
      centered,
      zIndex,
      mask,
      modalRender: () => /*#__PURE__*/_jsx(ModalRender, {
        ...renderProps,
        onClose: () => {
          var _modalRef$current4;
          return (_modalRef$current4 = modalRef.current) === null || _modalRef$current4 === void 0 ? void 0 : _modalRef$current4.destroy();
        }
      })
    });
  }, [modalRef.current]);
  return [{
    open,
    close,
    update
  }, widthContext ? contextHolder : undefined];
};
export default useModal;